import RoleEditor from './RoleEditor';

export default RoleEditor;
